<div class="p-6 2xl:p-0">
  <router-outlet></router-outlet>
</div>
